<template>
  <div class="home" id="home">
    <div class="header">
      <h1>佛 吉 亚 （ 常 熟 ） 汽 车 部 件 系 统 有 限 公 司</h1>
      <!-- <h1>Faurecia (Changshu) Automotive Parts Systems Co., Ltd</h1> -->
    </div>
    <div class="bg_warp">
      <div class="bg">
        <svg viewBox="0 0 1000 600" class="layout-map">
          <image href="@/assets/bg_main_area.png" x="25" y="25" width="950" height="550" class="zb_bg" />
          <image href="@/assets/bz.png" x="760" y="80" width="50" height="50" class="zb_bg" />
          <!-- 其他 -->
          <path
            d="M 300 106 L 680 106 L 680 120 L 350 120 L 350 145 L 320 145 L 320 450 L 350 450 L 350 500 L 300 500 Z"
            :fill="isUnderConstruction('CQWW') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('CQWW')" />
          <text x="310" y="300" class="area-text area-text-col" @click="toggleConstruction('CQWW')">公共区域</text>
          <!-- 施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('CQWW')" x="305" y="336" width="10" height="10"
            class="zb_bg" />
          <text x="310" y="356" v-if="isUnderConstruction('CQWW')" class="area-text area-text-col smll">{{
            getOrderNum('CQWW') }}</text>
          <!-- 门卫室1 -->
          <path d="M 320 80
         L 375 80 A5 5 0 0 1 380 85 L 380 95 A5 5 0 0 1 375 100
         L 325 100 A5 5 0 0 1 320 95 L 320 85 A5 5 0 0 1 325 80
         Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2" class="area-path" />
          <image href="@/assets/ry.png" x="330" y="85" width="10" height="10" class="zb_bg" />
          <text x="360" y="94" class="area-text smll mw_txt">门卫1</text>
          <!-- 门卫室2 -->
          <path d="M 700 80
         L 745 80 A5 5 0 0 1 750 85 L 750 95 A5 5 0 0 1 745 100
         L 705 100 A5 5 0 0 1 700 95 L 700 85 A5 5 0 0 1 705 80
         Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2" class="area-path" />
          <image href="@/assets/ry.png" x="703" y="85" width="10" height="10" class="zb_bg" />
          <text x="730" y="94" class="area-text smll mw_txt">门卫2</text>
          <!-- 食堂 -->
          <path d="M 350 120 L 680 120 L 680 145 L 350 145 Z" :fill="isUnderConstruction('ST') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('ST')" />
          <!-- 食堂施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('ST')" x="540" y="127" width="10" height="10"
            class="zb_bg" />
          <text x="560" y="137" v-if="isUnderConstruction('ST')" class="area-text smll">{{
            getOrderNum('ST') }}</text>
          <text x="520" y="137" class="area-text" @click="toggleConstruction('ST')">餐厅</text>


          <!-- 设备辅房 配电房 -->
          <path d="M 320 145 L 350 145 L 350 196 L 320 196 Z" :fill="isUnderConstruction('PDF') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('PDF')" />
          <path d="M 320 165 L 280 165 " stroke="#FF3D00" stroke-width="2" class="area-path"
            v-if="isUnderConstruction('PDF')" />
          <!-- 配电房施工信息 -->
          <!-- 配电房施工信息气泡 -->
          <path d="M 230 155 L 280 155 L 280 175 L 230 175 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('PDF')" />
          <image href="@/assets/ry3.png" x="234" y="160" v-if="isUnderConstruction('PDF')" width="10" height="10"
            class="zb_bg" />
          <text x="254" y="170" class="area-text smll" v-if="isUnderConstruction('PDF')" style="fill: #ff6a3c;">{{
            getOrderNum('PDF') }}</text>

          <text x="335" y="170" class="area-text area-text-col" @click="toggleConstruction('PDF')">配电房</text>


          <!-- 设备辅房 空压机房-->
          <path d="M 320 196 L 350 196 L 350 245 L 320 245 Z"
            :fill="isUnderConstruction('KYJF') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('KYJF')" />
          <path d="M 320 220 L 280 220 " stroke="#FF3D00" stroke-width="2" class="area-path"
            v-if="isUnderConstruction('KYJF')" />
          <!-- 空压机房施工信息 -->
          <!-- 空压机房施工信息气泡 -->
          <path d="M 230 210 L 280 210 L 280 230 L 230 230 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('KYJF')" />
          <image href="@/assets/ry3.png" v-if="isUnderConstruction('KYJF')" x="234" y="215" width="10" height="10"
            class="zb_bg" />
          <text x="254" y="225" v-if="isUnderConstruction('KYJF')" class="area-text smll" style="fill: #ff6a3c;">{{
            getOrderNum('KYJF') }}</text>
          <text x="335" y="220" style="font-size: 12px;" class="area-text area-text-col"
            @click="toggleConstruction('KYJF')">空压机房</text>



          <!-- 办公区 -->
          <path d="M 320 245 L 350 245 L 350 400 L 320 400 Z"
            :fill="isUnderConstructionArr(['1FBGQ', '2FBGQ', '2FHYS']) ? '#FF3D00' : '#0026CD'" stroke="#ffffff"
            stroke-width="1" class="area-path" @click="toggleConstruction(['1FBGQ', '2FBGQ', '2FHYS'])" />
          <!-- 办公区施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstructionArr(['1FBGQ', '2FBGQ', '2FHYS'])" x="330" y="350"
            width="10" height="10" class="zb_bg" />
          <text x="334" y="370" v-if="isUnderConstructionArr(['1FBGQ', '2FBGQ', '2FHYS'])"
            class="area-text area-text-col smll">{{ getOrderNumOffice() }}</text>
          <text x="335" y="325" class="area-text area-text-col"
            @click="toggleConstructionOffice(['1FBGQ', '2FBGQ', '2FHYS'])">办公区</text>


          <!-- IT机房 -->
          <path d="M 320 400 L 350 400 L 350 450 L 320 450 Z"
            :fill="isUnderConstruction('ITJF') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('ITJF')" />
          <path d="M 320 420 L 280 380 " stroke="#FF3D00" stroke-width="2" class="area-path"
            v-if="isUnderConstruction('ITJF')" />
          <!-- IT机房施工信息气泡 -->
          <path d="M 230 370 L 280 370 L 280 390 L 230 390 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('ITJF')" />
          <image href="@/assets/ry3.png" v-if="isUnderConstruction('ITJF')" x="234" y="375" width="10" height="10"
            class="zb_bg" />
          <text x="254" y="385" v-if="isUnderConstruction('ITJF')" class="area-text smll" style="fill: #ff6a3c;">{{
            getOrderNum('ITJF') }}</text>
          <text x="335" y="418" class="area-text" style="font-size: 12px;" @click="toggleConstruction('ITJF')">IT</text>
          <text x="335" y="435" class="area-text" style="font-size: 10px;" @click="toggleConstruction('ITJF')">Room</text>
          <!-- Cutting -->
          <!-- <path d="M 350 145 L 543 145 L 543 196 L 504 196 L 504 372 L 398 372 L 398 196 L 350 196 Z"
            :fill="isUnderConstruction('cutting') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('cutting')" />
          <text x="452" y="280" class="area-text">Cutting</text> -->

          <!-- Cutting 牛皮 -->
          <path d="M 350 145 L 543 145 L 543 196 L 350 196 Z" :fill="isUnderConstruction('NP') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('NP')" />
          <!-- 牛皮 -->
          <text x="442" y="176" class="area-text" @click="toggleConstruction('NP')">Leather</text>
          <!-- 牛皮施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('NP')" x="462" y="168" width="10" height="10"
            class="zb_bg" />
          <text x="482" y="176" v-if="isUnderConstruction('NP')" class="area-text smll">{{ getOrderNum('NP') }}</text>

          <!-- Cutting 大冲 -->
          <path d="M 398 196 L 487 196 L 487 284 L 398 284 Z" :fill="isUnderConstruction('DC') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('DC')" />
          <!-- 大冲施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('DC')" x="430" y="256" width="10" height="10"
            class="zb_bg" />
          <text x="450" y="265" v-if="isUnderConstruction('DC')" class="area-text smll">{{ getOrderNum('DC') }}</text>
          <!-- 大冲 -->
          <text x="442" y="247" class="area-text" @click="toggleConstruction('DC')">Punching</text>

          <!-- Cutting 织物 -->
          <path d="M 398 284 L 487 284 L 487 344 L 398 344 Z" :fill="isUnderConstruction('ZW') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('ZW')" />
          <!-- 织物施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('ZW')" x="430" y="326" width="10" height="10"
            class="zb_bg" />
          <text x="450" y="336" v-if="isUnderConstruction('ZW')" class="area-text smll">{{ getOrderNum('ZW') }}</text>
          <!-- 织物 -->
          <text x="442" y="320" class="area-text" @click="toggleConstruction('ZW')">Fabric</text>

          <!-- Cutting WIP -->
          <path
            d="M 487 196 L 505 196 L 505 430 L 621 430 L 621 450 L 487 450 L 487 372 L 398 372 L 398 344 L 487 344 Z"
            :fill="isUnderConstruction('WIP') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('WIP')" />
          <!-- WIP施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('WIP')" x="460" y="354" width="10" height="10"
            class="zb_bg" />
          <text x="480" y="363" v-if="isUnderConstruction('WIP')" class="area-text smll">{{ getOrderNum('WIP') }}</text>
          <text x="442" y="363" class="area-text" @click="toggleConstruction('WIP')">WIP</text>

          <!-- Assembly BR206 -->
          <path d="M 398 372 L 487 372 L 487 450 L 398 450 Z"
            :fill="isUnderConstruction('BR206') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('BR206')" />
          <!-- BR206施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('BR206')" x="430" y="422" width="10" height="10"
            class="zb_bg" />
          <text x="450" y="430" v-if="isUnderConstruction('BR206')" class="area-text smll">{{ getOrderNum('BR206')
          }}</text>
          <text x="443" y="414" class="area-text" @click="toggleConstruction('BR206')">BR206</text>


          <!-- PC&L -->
          <path d="M 350 450 L 398 450 L 699 450 L 699 480 L 699 510 L 826 510 L 300 510 L 300 500 L 350 500 Z"
            :fill="isUnderConstruction('PC&L1-5M') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('PC&L1-5M')" />
          <!-- PC&L 1-5号门施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('PC&L1-5M')" x="550" y="480" width="10" height="10"
            class="zb_bg" />
          <text x="570" y="489" v-if="isUnderConstruction('PC&L1-5M')" class="area-text smll">{{ getOrderNum('PC&L1-5M')
          }}</text>
          <text x="493" y="490" @click="toggleConstruction('PC&L1-5M')" class="area-text">PC&L 1-5</text>

          <!-- PC&L 高位货架 -->
          <path d="M 350 196 L 398 196 L 398 245 L 350 245 Z"
            :fill="isUnderConstruction('GWHJ') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('GWHJ')" />
          <path d="M 350 225 L 280 245" stroke="#FF3D00" stroke-width="2" class="area-path"
            v-if="isUnderConstruction('GWHJ')" />
          <!-- 高位货架施工信息气泡 -->
          <path d="M 230 235 L 280 235 L 280 255 L 230 255 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('GWHJ')" />
          <image href="@/assets/ry3.png" v-if="isUnderConstruction('GWHJ')" x="234" y="240" width="10" height="10"
            class="zb_bg" />
          <text x="254" y="250" v-if="isUnderConstruction('GWHJ')" class="area-text smll" style="fill: #ff6a3c;">{{
            getOrderNum('GWHJ') }}</text>
          <text x="373" y="214" class="area-text" @click="toggleConstruction('GWHJ')" style="font-size: 12px;">High</text>
          <text x="373" y="232" class="area-text" @click="toggleConstruction('GWHJ')" style="font-size: 12px;">Rack</text>

          <!-- PC&L 原材料卷料区 -->
          <path d="M 350 245 L 398 245 L 398 450 L 350 450 Z"
            :fill="isUnderConstruction('YCJLQ') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('YCJLQ')" />
          <!-- PC&L 原材料卷料区 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('YCJLQ')" x="367" y="395" width="10" height="10"
            class="zb_bg" />
          <text x="372" y="413" v-if="isUnderConstruction('YCJLQ')" class="area-text area-text-col smll">{{
            getOrderNum('YCJLQ') }}</text>

          <text x="373" y="330" class="area-text area-text-col" @click="toggleConstruction('YCJLQ')">Raw Material
            Area</text>
          <!-- 门卫室3 -->
          <!-- <path d="M 775 485
         L 820 485 A5 5 0 0 1 825 490 L 825 500 A5 5 0 0 1 820 505
         L 780 505 A5 5 0 0 1 775 500 L 775 490 A5 5 0 0 1 780 485
         Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2" class="area-path" />
          <image href="@/assets/ry.png" x="780" y="490" width="10" height="10" class="zb_bg" />
          <text x="806" y="500" class="area-text smll mw_txt">门卫3</text> -->
          <!-- 门卫室4 -->
          <path d="M 245 425
         L 290 425 A5 5 0 0 1 295 430 L 295 440 A5 5 0 0 1 290 445
         L 250 445 A5 5 0 0 1 245 440 L 245 430 A5 5 0 0 1 250 425
         Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2" class="area-path" />
          <image href="@/assets/ry.png" x="250" y="430" width="10" height="10" class="zb_bg" />
          <text x="277" y="439" class="area-text smll mw_txt">门卫4</text>
          <!-- kong -->
          <path d="M 543 145 L 565 145 L 565 196 L 543 196 Z"
            :fill="isUnderConstruction('kong') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('kong')" />

          <!-- Assembly PIP扶手 -->
          <path
            d="M 610 145 L 665 145 L 665 165 L 680 165 L 680 185 L 680 240 L 621 240 L 621 210 L 504 210 L 504 196 L 610 196 Z"
            :fill="isUnderConstruction('PIP-FS') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('PIP-FS')" />
          <!-- PIP扶手施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('PIP-FS')" x="630" y="210" width="10" height="10"
            class="zb_bg" />
          <text x="650" y="220" v-if="isUnderConstruction('PIP-FS')" class="area-text smll">{{ getOrderNum('PIP-FS')
          }}</text>
          <text x="640" y="200" class="area-text" @click="toggleConstruction('PIP-FS')">PIP-AR</text>

          <!-- Assembly  PIP-头枕-->
          <path d="M 565 145 L 610 145 L 610 196 L 565 196 Z"
            :fill="isUnderConstruction('PIP-TZ') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('PIP-TZ')" />
          <path d="M 585 145 L 585 85" stroke="#FF3D00" stroke-width="2" v-if="isUnderConstruction('PIP-TZ')"
            class="area-path" />
          <path d="M 555 65 L 610 65 L 610 85 L 555 85 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('PIP-TZ')" />
          <image href="@/assets/ry3.png" v-if="isUnderConstruction('PIP-TZ')" x="560" y="70" width="10" height="10"
            class="zb_bg" />
          <text x="580" y="80" v-if="isUnderConstruction('PIP-TZ')" class="area-text smll" style="fill: #ff6a3c;">{{
            getOrderNum('PIP-TZ') }}</text>
          <text x="586" y="165" class="area-text" @click="toggleConstruction('PIP-TZ')">PIP</text>
          <text x="586" y="185" class="area-text" @click="toggleConstruction('PIP-TZ')">-HR</text>

          <!-- Sewing M3 -->
          <path d="M 505 210 L 621 210 L 621 235 L 505 235 Z" :fill="isUnderConstruction('M3') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('M3')" />
          <!-- M3施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('M3')" x="588" y="219" width="10" height="10"
            class="zb_bg" />
          <text x="603" y="228" v-if="isUnderConstruction('M3')" class="area-text smll">{{ getOrderNum('M3') }}</text>
          <text x="547" y="228" class="area-text" v-if="isUnderConstruction('M3')" style="font-size: 12px;" @click="toggleConstruction('M3')">Sewing Line 7</text>
          <text x="565" y="228" class="area-text" v-else style="font-size: 12px;" @click="toggleConstruction('M3')">Sewing Line 7</text>

          <!-- Sewing MY -->
          <path d="M 505 235 L 621 235 L 621 280 L 505 280 Z" :fill="isUnderConstruction('MY') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('MY')" />
          <!-- MY施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('MY')" x="550" y="263" width="10" height="10"
            class="zb_bg" />
          <text x="570" y="272" v-if="isUnderConstruction('MY')" class="area-text smll">{{ getOrderNum('MY') }}</text>
          <!-- 为了判断是否有正在施工的 -->
          <text x="564" y="254" class="area-text" v-if="isUnderConstruction('MY')" style="font-size: 12px;">Sewing Line 6</text>
          <text x="564" y="264" class="area-text" v-else style="font-size: 12px;">Sewing Line 6</text>

          <!-- Sewing X03 -->
          <path d="M 505 280 L 621 280 L 621 325 L 505 325 Z" :fill="isUnderConstruction('X03') ? '#FF3D00' : '#0026CD'"
            stroke="#ffffff" stroke-width="1" class="area-path" @click="toggleConstruction('X03')" />
          <!-- X03施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('X03')" x="550" y="308" width="10" height="10"
            class="zb_bg" />
          <text x="570" y="317" v-if="isUnderConstruction('X03')" class="area-text smll">1</text>

          <text x="564" y="300" class="area-text" style="font-size: 12px;" @click="toggleConstruction('X03')" v-if="isUnderConstruction('X03')">Sewing Line 5</text>
          <text x="564" y="307" class="area-text" style="font-size: 12px;" @click="toggleConstruction('X03')" v-else>Sewing Line 5</text>

          <!-- Sewing EC11 -->
          <path d="M 505 325 L 621 325 L 621 372 L 505 372 Z"
            :fill="isUnderConstruction('EC11') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('EC11')" />
          <!-- EC11施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('EC11')" x="553" y="354" width="10" height="10"
            class="zb_bg" />
          <text x="572" y="364" v-if="isUnderConstruction('EC11')" class="area-text smll">{{
            getOrderNum('EC11') }}</text>

          <text x="564" y="344" class="area-text" style="font-size: 12px;" @click="toggleConstruction('EC11')" v-if="isUnderConstruction('EC11')">Sewing Line 3-4</text>
          <text x="564" y="352" class="area-text" style="font-size: 12px;" @click="toggleConstruction('EC11')" v-else>Sewing Line 3-4</text>

          <!-- Sewing Audi -->
          <path d="M 505 372 L 621 372 L 621 450 L 505 450 Z"
            :fill="isUnderConstruction('Audi') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('Audi')" />
          <!-- Audi施工信息 -->
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('Audi')" x="552" y="410" width="10" height="10"
            class="zb_bg" />
          <text x="570" y="420" v-if="isUnderConstruction('Audi')" class="area-text smll">{{ getOrderNum('Audi')
          }}</text>

          <text x="564" y="404" class="area-text" style="font-size: 12px;" @click="toggleConstruction('Audi')">Chery</text>
           <path
            d="M 680 106 L 699 106 L 699 366  L 699 383 L 699 450 L 680 450 L 621 450 L 621 240 L 680 240 L 680 165 L 665 165 L 665 145 L 680 145 Z"
            :fill="isUnderConstruction('PC&L6-7M') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('PC&L6-7M')" />
          <image href="@/assets/ry2.png" v-if="isUnderConstruction('PC&L6-7M')" x="635" y="335" width="10" height="10"
            class="zb_bg" />
          <text x="640" y="355" v-if="isUnderConstruction('PC&L6-7M')" class="area-text area-text-col smll">{{
            getOrderNum('PC&L6-7M') }}</text>
          <text x="660" y="346" class="area-text area-text-col" @click="toggleConstruction('PC&L6-7M')">PC&L 6-7</text>

          <!-- PC&L 化学品仓 -->
          <path d="M 665 145 L 680 145 L 680 165 L 665 165 Z"
            :fill="isUnderConstruction('HXPCK') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('HXPCK')" />
          <path d="M 680 155 L 720 155 " stroke="#FF3D00" stroke-width="2" class="area-path"
            v-if="isUnderConstruction('HXPCK')" />
          <!-- 化学品仓施工信息气泡 -->
          <path d="M 720 145 L 780 145 L 780 165 L 720 165 Z" fill="#fff3ef" stroke="#ff3e01" stroke-width="2"
            class="area-path" v-if="isUnderConstruction('HXPCK')" />
          <image href="@/assets/ry3.png" v-if="isUnderConstruction('HXPCK')" x="725" y="150" width="10" height="10"
            class="zb_bg" />
          <text x="745" y="160" v-if="isUnderConstruction('HXPCK')" class="area-text smll" style="fill: #ff6a3c;">{{
            getOrderNum('HXPCK') }}</text>
          <text x="660" y="146" class="area-text sm-size" @click="toggleConstruction('HXPCK')">化学</text>
          <text x="660" y="160" class="area-text sm-size" @click="toggleConstruction('HXPCK')">品仓</text>

          <!-- 新项目车间 -->
          <!-- <path d="M 680 383 L 826 383 L 826 480 L 680 480 Z"
            :fill="isUnderConstruction('XMXCJ') ? '#FF3D00' : '#0026CD'" stroke="#ffffff" stroke-width="1"
            class="area-path" @click="toggleConstruction('XMXCJ')" /> -->
          <!-- 新项目车间施工信息 -->
          <!-- <image href="@/assets/ry2.png" v-if="isUnderConstruction('XMXCJ')" x="730" y="450" width="10" height="10"
            class="zb_bg" />
          <text x="750" y="459" v-if="isUnderConstruction('XMXCJ')" class="area-text smll">{{ getOrderNum('XMXCJ')
          }}</text>
          <text x="750" y="436" class="area-text" @click="toggleConstruction('XMXCJ')">Program Area</text> -->
        </svg>
      </div>

    </div>
    <el-dialog v-model="dialogVisible" title="选择楼层" width="500">
      <!-- <span>{{ loftList }}</span> -->
      <el-radio-group v-model="areaId" @change="handleAreaChange" size="large">
        <el-radio-button v-for="item in loftList" :label="item.areaInfoName" :value="item.id" :key="item.id" />
      </el-radio-group>
    </el-dialog>
  </div>
</template>

<script>
import router from '../router';
import { ElMessage } from 'element-plus'
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import axios from 'axios';
import { areaInfoOrderList } from '@/api/index';

export default {
  name: 'HomeView',
  setup() {
    // 响应式数据
    const constructionAreas = ref([]);
    const constructObjArr = ref([]);
    const allArr = ref([])
    const timer = ref(null);
    const updateInterval = ref(6000);
    const isLoading = ref(false);
    const retryCount = ref(0);
    const MAX_RETRY = 3;
    const cancelSource = ref(null);
    const dialogVisible = ref(false);
    const loftList = ref([])
    const areaId = ref(undefined)

    // 方法
    const loadDataWithFeedback = async () => {
      try {
        isLoading.value = true;
        await loadData();
        retryCount.value = 0;
      } catch (error) {
        if (retryCount.value < MAX_RETRY) {
          retryCount.value++;
          setTimeout(loadDataWithFeedback, 2000);
        } else {
          console.log('数据更新失败，请检查网络连接');
        }
      } finally {
        isLoading.value = false;
      }
    };

    const loadData = async () => {
      try {
        if (cancelSource.value) {
          cancelSource.value.cancel('取消旧请求');
        }

        const CancelToken = axios.CancelToken;
        cancelSource.value = CancelToken.source();

        const res = await areaInfoOrderList({
          cancelToken: cancelSource.value.token,
          timeout: 5000,
        });

        processResponse(res.data);
      } catch (error) {
        if (!axios.isCancel(error)) {
          throw error;
        }
      }
    };

    const processResponse = (data) => {
      const tempAreas = [];
      const tempObjArr = [];

      data.forEach((area) => {
        if (area.lbyBusinessMaintenanceOrderList?.length > 0) {
          tempAreas.push(area.areaKey);
          tempObjArr.push({
            id: area.id,
            areaKey: area.areaKey,
            areaInfoName: area.areaInfoName,
            orderNum: area.lbyBusinessMaintenanceOrderList.length,
            timestamp: Date.now(),
          });
        }
      });

      // 直接赋值触发响应式更新
      constructionAreas.value = tempAreas;
      constructObjArr.value = tempObjArr;
      allArr.value = data;
    };

    const getOrderNum = (areaKey) => {
      const found = constructObjArr.value.find((item) => item.areaKey === areaKey);
      return found ? found.orderNum : 0;
    };
    const getName = (areaKey) => {
      const found = allArr.value.find((item) => item.areaKey === areaKey);
      return found ? found.areaInfoName : '--';
    };

    const getOrderNumOffice = () => {
      let orderNum = 0;
      const arr = ['1FBGQ', '2FBGQ', '2FHYS'];
      arr.forEach((item) => {
        if (constructionAreas.value.includes(item)) {
          orderNum += getOrderNum(item);
        }
      })
      return orderNum ? orderNum : 0;
    };

    const toggleConstructionOffice = () => {
      loftList.value = [
        //   {
        //   areaEnglishInfoName: "1FBGQ",
        //   areaInfoName: "1F办公区",
        //   areaKey: "1FBGQ",
        //   id: 17,
        //   lbyBusinessMaintenanceOrderList: []
        // }, {
        //   areaEnglishInfoName: "2FBGQ",
        //   areaInfoName: "2F办公区",
        //   areaKey: "2FBGQ",
        //   id: 18,
        //   lbyBusinessMaintenanceOrderList: []
        // }, {
        //   areaEnglishInfoName: "2FHYS",
        //   areaInfoName: "2F会议室",
        //   areaKey: "2FHYS",
        //   id: 19,
        //   lbyBusinessMaintenanceOrderList: []
        // }
      ];
      const arr = ['1FBGQ', '2FBGQ', '2FHYS'];
      arr.forEach((item) => {
        if (constructionAreas.value.includes(item)) {
          loftList.value.push(item)
        }
      })
      if (loftList.value.length <= 0) {
        ElMessage.warning('该区域未在施工')
        return;
      }

      dialogVisible.value = true;
    }

    const startPolling = () => {
      timer.value = setInterval(loadDataWithFeedback, updateInterval.value);
    };

    const stopPolling = () => {
      clearInterval(timer.value);
      timer.value = null;
      if (cancelSource.value) {
        cancelSource.value.cancel('组件卸载，取消请求');
      }
    };

    // 生命周期
    onMounted(() => {
      loadDataWithFeedback();
      startPolling();
    });

    onBeforeUnmount(() => {
      stopPolling();
    });

    // 监听数据变化
    watch(constructObjArr, (newVal) => {
      // 触发事件
    }, { deep: true });

    // 获取是否正在施工
    const isUnderConstructionArr = (arr) => {
      let result = false;
      arr.some((item) => {
        if (constructionAreas.value.includes(item)) {
          result = true;
          return true;
        }
      })
      return result
    }

    const isUnderConstruction = (areaId) => {
      return constructionAreas.value.includes(areaId)
    }

    const handleAreaChange = (e) => {
      dialogVisible.value = false;
      router.push({
        name: 'ConstructionTable',
        query: {
          areaId: e
        }
      })
    }

    // 跳转详情
    const toggleConstruction = (areaKey) => {
      const found = constructObjArr.value.find((item) => item.areaKey === areaKey);
      if (found && found.id) {
        router.push({
          name: 'ConstructionTable',
          query: {
            areaId: found.id
          }
        })
      } else {
        ElMessage({
          message: '该区域未在施工',
          type: 'warning',
        })
      }
    }

    return {
      dialogVisible,
      loftList,
      areaId,
      constructionAreas,
      constructObjArr,
      loadDataWithFeedback,
      getOrderNum,
      isUnderConstructionArr,
      isUnderConstruction,
      getOrderNumOffice,
      toggleConstruction,
      toggleConstructionOffice,
      handleAreaChange,
      getName
      // ...其他需要暴露的属性和方法
    };
  },
};
</script>

<style scoped>
.home {
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.header {
  flex-shrink: 0;
}

.header h1 {
  margin: 10px;
}

.bg_warp {
  position: relative;
  width: 100%;
  padding: 20px 150px 20px 150px;
  flex-grow: 1;
  box-sizing: border-box;
}

.bg {
  position: relative;
  width: 100%;
  height: 100%;
}

.bg_img {
  width: auto;
  height: 100%;
  object-fit: contain;
}

.factory-map {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.map-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.svg-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4/3;
}

.layout-map {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
}

.area-path {
  cursor: pointer;
  transition: opacity 0.3s;
}

.area-path {
  opacity: 0.76;
}

.area-text {
  fill: #fff;
  font-size: 14px;
  text-anchor: middle;
  user-select: none;
}

.smll {
  font-size: 12px;
}

.area-text-col {
  fill: #fff;
  writing-mode: vertical-rl;
  dominant-baseline: central;
}

.compass-text {
  font-size: 12px;
}

.legend {
  margin-top: 20px;
}

.legend-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.legend-items {
  display: flex;
  gap: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-box {
  width: 16px;
  height: 16px;
  border: 1px solid #1976d2;
}

.color-box.normal {
  background-color: #e3f2fd;
}

.color-box.construction {
  background-color: #ff9800;
}

.mw_txt {
  fill: #ff3e01;
}

.sm-size {
  transform: scale(0.51) translate(65.9%, 26.2%);
}
</style>